import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import CmsPage from "./CmsPage";
import GoalDetail from "./GoalDetail";

/**
 * /conditions/:slug resolver.
 *
 * Historically /conditions/:slug rendered <GoalDetail /> (the hardcoded set of
 * treatment goals seeded into TREATMENT_GOALS). We now ALSO have CMS-seeded
 * condition pages under content_pages.page_type='condition'.
 *
 * Priority: try the LEGACY GoalDetail first (it has rich, medically-vetted,
 * hand-authored content). If no goal exists for the slug, fall back to CMS.
 * This lets new conditions be added via the CMS without ever overriding an
 * existing, higher-quality hardcoded goal page.
 */
export default function ConditionResolver() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: "checking", source: null });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "checking", source: null });
    // Try legacy goal first.
    api.get(`/goals/${slug}`)
      .then(() => { if (!cancelled) setState({ status: "resolved", source: "goal" }); })
      .catch(() => {
        // Goal missing → try CMS.
        api.get(`/content/condition/${slug}`)
          .then(() => { if (!cancelled) setState({ status: "resolved", source: "cms" }); })
          .catch(() => { if (!cancelled) setState({ status: "resolved", source: "none" }); });
      });
    return () => { cancelled = true; };
  }, [slug]);

  if (state.status === "checking") {
    return <div className="vv-container py-24 text-stone-500">Loading…</div>;
  }
  if (state.source === "goal") return <GoalDetail />;
  if (state.source === "cms")  return <CmsPage pageType="condition" />;
  // Nothing found — render the CMS not-found path (has a friendly UI).
  return <CmsPage pageType="condition" />;
}
